class videosCarousel {

  constructor(items, id, maxItems = null) {
    let self = this
    this.items = items
    this.id = id
    this.maxItems = maxItems ? maxItems : this.items.length
    this.initialized = false
    this.carouselContainer = document.getElementById(id)
    this.carousel = this.carouselContainer.querySelector('.swiper-container')
    this.carouselWrapper = this.carousel.querySelector('.swiper-wrapper')
    this.createSlides()
    this.createCarousel()
    this.swiper = this.carousel.swiper;
    //this.swiper.init()
    // Stop embed video when closing the modal.
    this.carouselContainer.querySelector('.close').addEventListener('click', (e) => {
      self.resetAllVideos(self.swiper)
    })

    this.carouselContainer.addEventListener('click', (e) => {
      if (e.target === this.carouselContainer) {
        self.carouselContainer.classList.remove('open')
        self.resetAllVideos(self.swiper)
      }
    })
  }

  createSlides() {
    for (let i = 0; i < this.maxItems; i++) {
      let item = this.items[i]
      this.createSlide(item)
    }
  }

  createSlide(itemData) {
    let videoUrl = 'https://player.vimeo.com/video/' + itemData.vimeoId

    let slide = document.createElement('div')
    slide.classList.add('swiper-slide')

    let video = document.createElement('div')
    video.classList.add('modal-worker-video')
    video.setAttribute('data-videourl', videoUrl)
    video.innerHTML = this.getVideoEmbedMarkup(videoUrl)

    let name = document.createElement('div')
    name.classList.add('modal-worker-name')
    name.innerHTML = itemData.name

    let place = document.createElement('div')
    place.classList.add('modal-worker-place')
    place.innerHTML = itemData.place

    let job = document.createElement('div')
    job.classList.add('modal-worker-job')
    job.innerHTML = itemData.jobTitle

    let quote = document.createElement('div')
    quote.classList.add('modal-worker-quote')
    quote.innerHTML = '<p>' + itemData.quote + '</p>'

    let watchFullVideo = document.createElement('div')
    watchFullVideo.classList.add('modal-worker-watch-full')
    watchFullVideo.innerHTML = '<a href="' + itemData.fullVideoUrl + '" target="_blank">' + fullVideoLabel + '</a>'

    slide.appendChild(video)
    slide.appendChild(name)
    slide.appendChild(place)
    slide.appendChild(job)
    slide.appendChild(quote)
    slide.appendChild(watchFullVideo)

    this.carouselWrapper.appendChild(slide)
  }

  createCarousel() {
    let self = this
    new Swiper(this.carousel, {
      loop: false,
      speed: 500,
      threshold: 20,
      // If we need pagination
      pagination: {
        el: self.carouselContainer.querySelector('.swiper-pagination'),
      },
      navigation: {
        nextEl: self.carouselContainer.querySelector('.swiper-button-next'),
        prevEl: self.carouselContainer.querySelector('.swiper-button-prev'),
      },
      on: {
        init: function () {
          self.initialized = true
        },
        slideChangeTransitionStart: function () {
          if (self.initialized === true) {
            self.resetPreviousVideo(this)
            self.playVideo(this)
          }
        },
      }
    })
  }

  getVideoEmbedMarkup(videoUrl, autoplay = 1) {
    return '<iframe src="' + videoUrl +
      '?loop=0&autopause=0&texttrack=' + appLanguage + '" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>'
  }
  playVideo(swiper) {
    let slides = swiper.slides,
      currentSlide = slides[swiper.activeIndex],
      video = currentSlide.querySelector('.modal-worker-video'),
      iframe = video.querySelector('iframe')

    if (iframe) {
      let player = new Vimeo.Player(iframe)
      player.setCurrentTime(0)
      player.play()
    }
  }

  resetAllVideos(swiper) {
    let slides = swiper.slides
    for (let i = 0; i < slides.length; i++) {
      let currentSlide = slides[i],
        video = currentSlide.querySelector('.modal-worker-video'),
        iframe = video.querySelector('iframe')

      this.stopVideo(iframe)
    }
  }

  resetPreviousVideo(swiper) {
    let previousIndex = swiper.previousIndex,
      currentSlide = swiper.slides[previousIndex],
      video = currentSlide.querySelector('.modal-worker-video'),
      iframe = video.querySelector('iframe')

    this.stopVideo(iframe)
  }

  stopVideo(iframe) {
    if (iframe) {
      let player = new Vimeo.Player(iframe)
      player.setCurrentTime(0)
      player.pause()
    }
  }
}